/* eslint-disable import/no-default-export */
import { configureMakeStore, getOrCreateStore } from '@gasket/redux';
import { createWrapper, HYDRATE } from 'next-redux-wrapper';
import thunk from 'redux-thunk';
import { reducers } from './reducers';
import { Store } from 'redux';
import { AbstractModel } from './models/AbstractModel';
import moment from 'moment/moment';
import merge from 'lodash.merge';
import { RootState } from '../types/redux/states/RootState';
import { getLocale } from './selectors/getLocale';
import { endpoints } from './endpoints';
import { RumThunk } from '@wsb/gasket-advanced-apm-rum/client';
import { GrowlThunk } from './helpers/GrowlThunk';
import { ServerLogger } from './helpers/ServerLogger';
import { ThunkExtraArgs } from '../types/redux/utils/ThunkExtraArgs';
import { ClientTacker } from './helpers/ClientTacker';

/**
 * Leaving here to help decode serverside dispatches
 */
// const logger: Middleware<any, RootState> = store => next => action => {
//   if (
//     ![
//       'LocaleApi_getLocaleManifest_SUCCESS',
//       'LocaleApi_getMessages_SUCCESS',
//       'LOAD_COOKIES'
//     ].includes(action.type)
//   ) {
//     console.group(action.type);
//     console.info('dispatching', action);
//     console.groupEnd();
//   }
//   return next(action);
// };

const rootReducer = (state: RootState, { type, payload }: any) => {
  if (type === HYDRATE) {
    return merge({}, state, payload);
  }
  return state;
};

const initCreateStore = (
  config: Record<string, any> = {
    middleware: [...endpoints.filter(f => 'middleware' in f).map(f => f.middleware)],
    rootReducer,
    reducers
  },
  callBack: (store: Store) => void = () => null
) => {
  const optionsCallback = (options: { req: any }) => {
    const thunkContext: ThunkExtraArgs = {};

    if (options.req) {
      //server side
      thunkContext.serverAuthCookie = options.req.headers.cookie;
      thunkContext.serverLogger = new ServerLogger();
    } else {
      //client side
      thunkContext.clientGrowl = new GrowlThunk();
      thunkContext.rumClient = new RumThunk();
      thunkContext.clientTracker = new ClientTacker();
    }

    const thunkMiddleware = thunk.withExtraArgument(thunkContext);
    return { ...config, thunkMiddleware };
  };

  const makeStore = configureMakeStore(optionsCallback, (store: Store) => {
    callBack(store);
    AbstractModel.setStateGetter(store.getState);

    moment.locale(getLocale(store.getState()));
    return store;
  });

  makeStore.nextRedux = createWrapper(getOrCreateStore(makeStore));
  return makeStore;
};

module.exports = { initCreateStore };
